<form [formGroup]="form">
  <app-input-group>
    <label appLabel>Skæringsdato</label>
    <input type="date" appInput formControlName="validFrom">
  </app-input-group>

  <app-input-group>
    <label appLabel>Målernummer</label>
    <select appSelect formControlName="meterNumber">
      <option value="null" selected disabled>Vælg måler</option>
      @for (item of meterList; track item.id) {
        <option [value]="item.id">
          {{ item.serialNumber ? `Serienummer: ${item.serialNumber}` : '' }} {{ item.alternateMeterNumber ? `- Placering: ${item.alternateMeterNumber}` : '' }} {{ item.meterNumber ? `- Målernummer: ${item.meterNumber}` : 'Ingen målernummer' }}
        </option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>Målerserienummer</label>
    <input type="text" appInput formControlName="serialNumber">
  </app-input-group>

  <app-input-group>
    <label appLabel>Kvadrant</label>
    <select appSelect formControlName="quadrant">
      <option value="null" disabled selected>Vælg kvadrant</option>
      @for (item of quadrant; track item.key) {
        <option [value]="item.key">
          {{ item.value | translate }}
        </option>
      }
    </select>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meter.createcontrolmeter.relativedeviation' | translate }}</label>
    <input appInput type="number" formControlName="relativeDeviation"
           append="%">
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meteringpoint.meter.createcontrolmeter.absolutedeviation' | translate }}</label>
    <input appInput type="number" formControlName="absoluteDeviation"
           append="kWh">
  </app-input-group>
</form>
